import React from "react"
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Image from "next/image";
import CCOLinkable from "../../fundamentals/CCOLinkable";
import useWindowSize from "../../../utility/useWindowSize";
import {CmCollectionType} from "../../types";
import {resolveMediaUri} from "../../../utility/cdnPictureUtil";


export interface Props {
    cmCollection: CmCollectionType,
}


function C073TrustBar(props: Props) {
    const {lowerThanWindowLarge} = useWindowSize();
    const stackStyleCenter = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        alignContent: 'center'
    }
    const noStackStyle = {}
    return (
        <>
            <Box sx={{
                alignSelf: 'center',
                justifySelf: 'center',
                width: '100%',
                height: '100%',
                padding: '24px 16px 16px 16px',
            }}>
                <Stack
                    direction="row"
                    style={lowerThanWindowLarge ? stackStyleCenter : noStackStyle}
                    sx={{
                        alignItems: "center",
                        gap: 4
                    }}>
                    {
                        props.cmCollection.items?.map((item: any, index: number) => (

                            <Box key={index} sx={{textAlign: 'center'}}>
                                {item.globalFactsSettings?.teaser_icon ?
                                    <CCOLinkable dataCypress={'trustLink' + index} noLinkIcon
                                                 openInTab target={item}>
                                        <Image loading={'lazy'}
                                               alt={item.teaserTitle}
                                               src={resolveMediaUri(item.globalFactsSettings?.teaser_icon)}
                                               width={0}
                                               height={0}
                                               style={{
                                                   width: 'auto',
                                                   height: '56px',
                                               }}
                                        />
                                    </CCOLinkable>
                                    : null}
                            </Box>
                        ))
                    }
                </Stack>

            </Box>
        </>
    );
}

export default C073TrustBar